import { WsAutocompleteInput } from 'wisestep-base';

import WsAccordion from '../../components/WsAccordion';
import WsFilterProps from '../../models/WsFilterProps';

const SkillsFilter = ({ name }: WsFilterProps) => (
  <WsAccordion title="Skills">
    <WsAutocompleteInput
      name={name}
      options={[]}
      placeholder={`Enter Skills, comma separated`}
      freeSolo={true}
      multiple={true}
    />
  </WsAccordion>
);

export default SkillsFilter;
